module.exports = __webpack_public_path__ + "img/Somaliland.c34862b9.svg";